import React from "react";
import { Plus } from "lucide-react";

/**
 * CreateButton - Shared create button component
 * 
 * Provides consistent create button for Events and Spaces with modal overlay handling.
 * Uses lucide-react Plus icon for consistency.
 * 
 * @param {Object} props
 * @param {string} props.label - Button label (e.g., "Create Event" or "Create Space")
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onOpen - Callback to open the modal
 * @param {Function} props.onClose - Callback to close the modal
 * @param {React.ReactNode} props.children - Form component to render in modal
 */
const CreateButton = ({ label, isOpen, onOpen, onClose, children }) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-center justify-items-center items-center md:mx-24">
            <button
                className="flex items-center px-4 py-2 bg-gradient-to-r from-grey-100 to-grey-200 text-neutral-green-500 rounded-2xl shadow-md hover:bg-gradient-to-br hover:from-red-50 hover:to-grey-100 hover:text-red-500 transition-colors duration-300 max-w-60 w-full min-h-72"
                aria-label={label}
                onClick={onOpen}
            >
                <Plus className="mr-2 h-5 w-5" />
                <span className="font-medium">{label}</span>
            </button>
            {isOpen && (
                <div
                    className="fixed inset-0 flex items-center justify-center bg-neutral-green-700 bg-opacity-50 z-10"
                    onClick={onClose}
                >
                    <div onClick={(e) => e.stopPropagation()}>{children}</div>
                </div>
            )}
        </div>
    );
};

export default CreateButton;
